/** Page-1 rhythm for PVM/GPS — keep left column dense; give right-column chart blocks more air. */
export const pvmWebCompact = {
  stackSpacing: 3,
  mainGridSpacing: 14,
  introGridSpacing: 5,
  sectionMarginBottom: 8,
  contentTitleMarginBottom: 3,
  contentTitlePaddingBottom: 1,
  contentTitle2MarginBottom: 1,
  contentTitle2PaddingBottom: 1,
  contentTextMarginBottom: 1,
  introMargin: '10px 0 3px',
  lineChartHeight: 325,
  barChartHeight: 170,
  pieChartMarginBottom: 4,
  page2GridSpacing: 12,
  disclaimerMarginTop: 0,
} as const;

export const pvmPdfPage1 = {
  /** Gap before NACH JAHREN / NACH PERIODEN / RISIKOINDIKATOREN blocks */
  chartBlockMarginTop: 8,
  chartImageMarginTop: 1,
  chartPlaceholderMarginTop: 3,
  contentHeaderMarginBottom: 0.2,
} as const;

/** Tighter key-value tables in web preview (PREISE / KONDITIONEN / STAMMDATEN). */
export const pvmWebDataTableSx = {
  '& .MuiTableCell-root': {
    height: '11px !important',
    minHeight: '11px',
    fontSize: '11px !important',
    py: '0px !important',
    lineHeight: 1.02,
  },
} as const;
